import React from 'react';

import {pluralise} from '@optimaxdev/utils';
import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';

import s from './supplyText.scss';

export type PropsType = {
    item: QuoteItemV2;
    inVista?: boolean;
    longMonth?: boolean;
};

/**
 * Component with supply text
 */
export const SupplyText: React.FC<PropsType> = ({inVista = false, item, longMonth = false}) => {
    const countOfSubscriptionMonths = Number(
        item.subscription?.currentSubscriptionPlan?.slice(0, -1),
    );
    return (
        <p
            aria-label="Checkout subscription months"
            className={classNames(s.supply, {[s.inVista]: inVista})}
        >
            Supply: Every {countOfSubscriptionMonths}{' '}
            {longMonth ? `${pluralise('month', countOfSubscriptionMonths)}` : 'mo.'}
        </p>
    );
};
